// extracted by mini-css-extract-plugin
module.exports = {"image":"SanityImage_image__3yzZH","animated":"SanityImage_animated__BEIOP","isLoaded":"SanityImage_isLoaded__v_o_v","isCover":"SanityImage_isCover__f59FS"};